import PeopleWFFMDataExchange from '@/services/PeopleWFFMDataExchange'

/**
 * A mixin adding people editing logic and data
 */
export default {
  data () {
    return {
      dx: { people: new PeopleWFFMDataExchange(this.form) },
      popups: { people: false },
      people: {
        adults: { value: 0, min: 0, max: 1 },
        children: { value: 0, min: 0, max: 1 },
        childrenBirthdays: [],
      },
    }
  },
  created () {
    this.people = this.dx.people.data
  },
  computed: {
    selectedPeopleValue () {
      const adults = this.people.adults.value
      const children = this.people.children.value
      return `Dorośli ${adults} / Dzieci ${children}`
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/search/logic/People.js